// extracted by mini-css-extract-plugin
export default {"form-grid":"l3cfkR","formGrid":"l3cfkR","button":"lxNd9p","instructions":"rb9wSP","splitSelect":"w0jvp4","lockedSplits":"FkYg2o"};